/* src/app/private/components/whatsapp-config/whatsapp-config/whatsapp-config.component.scss */
/*# sourceMappingURL=whatsapp-config.component.css.map */
